import React from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import { ICON_LIST } from '../../../../../../../lib/constants'
import IconItem from '../IconItem'
import styles from '../../FeatureIconEditor.module.scss'
import typeIcons from '../../../../../../../assets/featureType'

function IconList(props) {
	return (
		<>
			<div className={styles.iconItemsList}>
				{props.listItems.length
					? props.listItems.map((li, i) => {
						return <IconItem key={i} image={li.image} name={li.name} title={li.title} />
					})
					: null}
			</div>
		</>
	)
}

IconList.propTypes = {
	listItems: PropTypes.array
}

export default connect((model) => {
	const listItems = []
	for (let ili = 0; ili < ICON_LIST.length; ili++) {
		const { display, key } = ICON_LIST[ili]
		listItems.push({
			image: typeIcons[display.replace(/ /g, '')],
			name: key,
			title: display,
		})
	}
	return {
		listItems,
	}
})(IconList)
